import { getScrollBarWidth } from '~/plugins/_helpers'

export const FixBody = {
  data() {
    return {
      scrollTop: process.browser
        ? Math.max(
            window.pageYOffset,
            document.documentElement.scrollTop,
            document.body.scrollTop
          )
        : ''
    }
  },

  methods: {
    fixBody() {
      this.scrollTop = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      )

      const el = document.querySelector('#__nuxt')

      el.style.cssText = `top: -${
        this.scrollTop
      }px; padding-right: ${getScrollBarWidth()}px`

      el.querySelector(
        'header'
      ).style.cssText = `padding-right: ${getScrollBarWidth()}px`

      el.style.cssText =
        'overflow: hidden !important; position: fixed!important; top: 0; left: 0; right: 0; height: auto'

      return this.scrollTop
    },

    unfixBody() {
      const el = document.querySelector('#__nuxt')

      el.style.cssText = ''
      el.style.cssText = ''
      el.querySelector('header').style.cssText = `padding-right: 0px`
      process.browser ? window.scrollBy(0, this.scrollTop) : ''
      this.scrollTop = 0
    }
  }
}



// WEBPACK FOOTER //
// ./mixins/FixBody.js